import { isEmpty } from "lodash-es";
import React, { Fragment, useEffect, useState } from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

import { PromotionCode } from "lib/@types/service/cart/shared";

import "./discount.scss";
import { PromotionInputField } from "./promotionInput/promotionInputField.component";
import { PromotionList } from "./promotionList/promotionList.component";

type Props = {
    children?: string;
    promotionCodes: Array<PromotionCode>;
    isLoading: boolean;
    cartHasItems: boolean;
    addPromotionCode: (values: string, bonusCardNumber?: string) => void;
    removePromotionCode: (code: string) => void;
};

const Discount = ({
    promotionCodes,
    removePromotionCode,
    addPromotionCode,
    isLoading,
    cartHasItems,
}: Props) => {
    const { t } = useGranite();
    const [active, setActive] = useState(promotionCodes.length > 0);

    useEffect(() => {
        return function cleanUp() {
            setActive(false);
        };
    }, []);

    return (
        <Fragment>
            {cartHasItems && (
                <Fragment>
                    {active && (
                        <div className="discount-wrapper">
                            <PromotionInputField
                                addPromotionCode={addPromotionCode}
                                loading={isLoading}
                                setActive={setActive}
                                autofocus={isEmpty(promotionCodes)}
                            />
                            <PromotionList
                                promotions={promotionCodes}
                                removePromotionCode={removePromotionCode}
                            />
                        </div>
                    )}
                    {!active && (
                        <Button
                            className={"discount__button"}
                            test="discount-button-fillInDiscountCode"
                            color="link"
                            type="button"
                            onClick={() => setActive(true)}
                        >
                            <div className={"discount__button__tag"}></div>
                            <i className="las la-tags pr-1 d-none d-md-inline" />
                            <span className={"discount__button__content"}>
                                {t(
                                    "general.checkout.discount.label.fillInDiscountCode",
                                )}
                            </span>
                            <span
                                className={"discount__button__marker d-md-none"}
                            >
                                ●
                            </span>
                        </Button>
                    )}
                </Fragment>
            )}
        </Fragment>
    );
};

export { Discount };
